var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "over_layout" },
      [
        _c("section", { staticClass: "group" }, [
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "block_left" }, [
              _c("div", { staticClass: "title_block" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$store.getters.t("CV_in")) +
                    "\n            "
                ),
                _c("span", [_vm._v("5")]),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$store.getters.t("minutes")) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "block_under_title" }, [
                _vm._v(_vm._s(_vm.$store.getters.t("Just_3_simple_steps")))
              ]),
              _vm._v(" "),
              _c("ul", [
                _c(
                  "li",
                  {
                    staticClass: "c-p",
                    on: {
                      click: function($event) {
                        return _vm.openPaymentModal()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "icon_1" }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$store.getters.t("select")))])
                  ]
                ),
                _vm._v(" "),
                _c("li", [
                  _c("div", { staticClass: "icon_2" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$store.getters.t("edit")))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("div", { staticClass: "icon_3" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$store.getters.t("download")))])
                ])
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "add_circle",
                attrs: { "data-v-step": "1" },
                on: {
                  click: function($event) {
                    return _vm.openPaymentModal()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "scroll_two" }, [
              _c("a", {
                staticClass: "yakr_bt",
                on: { click: _vm.routerHashPush }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "create_your_resume", attrs: { id: "two_section" } },
          [
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "section_title" }, [
                _c("div", { staticClass: "light_inf_icon" }),
                _vm._v(" "),
                _c("h1", [
                  _vm._v(
                    _vm._s(_vm.$store.getters.t("Create_your_resume_right_now"))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text_type" }, [
                _vm._v(
                  _vm._s(_vm.$store.getters.t("Create_your_resume_large_text"))
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "numbers_block" }, [
                _c("ul", [
                  _c("li", [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$store.getters.t("resume")))])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$store.getters.t("created")))])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$store.getters.t("blog")))])
                  ])
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("section", { staticClass: "bestsellers" }, [
          _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "all_title_block left_title_block" }, [
              _c("div", { staticClass: "title_block" }, [
                _c("div"),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$store.getters.t("bestsellers")))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bestsellers_block" }, [
            _c("div", { staticClass: "wrapper" }, [
              _c(
                "div",
                { staticClass: "all_block_add" },
                [
                  !_vm.owl && !_vm.owlImages
                    ? [
                        _c("div", { staticClass: "blocks" }, [
                          _c(
                            "div",
                            { staticClass: "block" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "cv-create-u-2",
                                      lang: _vm.$store.getters.locale
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: { src: "/vue/images/cv_img_2.png" }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "block" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "cv-create-p-2",
                                      lang: _vm.$store.getters.locale
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: { src: "/vue/images/cv_img_3.png" }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "block" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "cv-create-u-1",
                                      lang: _vm.$store.getters.locale
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: { src: "/vue/images/cv_img_4.png" }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    : [
                        _c(
                          "carousel",
                          {
                            staticClass: "blocks",
                            attrs: {
                              margin: 10,
                              stagePadding: 20,
                              items: 3,
                              loop: true,
                              nav: false,
                              dots: true,
                              responsive: {
                                0: { items: 1 },
                                500: { items: 2 },
                                768: { items: 3 }
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "block" }, [
                              _c("img", {
                                attrs: { src: "/vue/images/cv_img_2.png" }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "block" }, [
                              _c("img", {
                                attrs: { src: "/vue/images/cv_img_3.png" }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "block" }, [
                              _c("img", {
                                attrs: { src: "/vue/images/cv_img_4.png" }
                              })
                            ])
                          ]
                        )
                      ],
                  _vm._v(" "),
                  _c("div", { staticClass: "block_add" }, [
                    _c("div", {
                      staticClass: "add_circle",
                      on: {
                        click: function($event) {
                          return _vm.openPaymentModal()
                        }
                      }
                    })
                  ])
                ],
                2
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("active-posts", { attrs: { posts: _vm.active_posts } }),
        _vm._v(" "),
        _c("section", { staticClass: "our_advantages" }, [
          _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "all_title_block left_title_block" }, [
              _c("div", { staticClass: "title_block" }, [
                _c("div"),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$store.getters.t("Our_advice")))])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wrapper wrapper_inner" },
            [
              !_vm.owl
                ? [
                    _c(
                      "div",
                      { staticClass: "block" },
                      [
                        _vm._l(_vm.advices, function(advice, index) {
                          return [
                            _c(
                              "div",
                              {
                                key: advice.at_id,
                                class: [
                                  index % 2 == 0 ? "right_part" : "left_part"
                                ]
                              },
                              [
                                _c("div", { staticClass: "img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: advice.photo,
                                      alt: advice.photo_title
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "all_text" }, [
                                  _c("div", { staticClass: "text" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "name",
                                        attrs: { title: advice.title }
                                      },
                                      [_vm._v(_vm._s(advice.name))]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [_vm._v(_vm._s(advice.content))])
                                  ])
                                ])
                              ]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ]
                : [
                    _c(
                      "carousel",
                      {
                        staticClass: "block",
                        attrs: {
                          margin: 10,
                          stagePadding: 10,
                          items: 1,
                          loop: true,
                          autoHeight: true,
                          nav: false,
                          dots: true
                        }
                      },
                      [
                        _vm._l(_vm.advices, function(advice, index) {
                          return [
                            _c(
                              "div",
                              {
                                key: advice.at_id,
                                class: [
                                  index % 2 == 0 ? "right_part" : "left_part"
                                ]
                              },
                              [
                                _c("div", { staticClass: "img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: advice.photo,
                                      title: advice.photo_title
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "all_text" }, [
                                  _c("div", { staticClass: "text" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "name",
                                        attrs: { title: advice.title }
                                      },
                                      [_vm._v(_vm._s(advice.name))]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [_vm._v(_vm._s(advice.content))])
                                  ])
                                ])
                              ]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ]
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "feedback" }, [
          _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "all_title_block right_title_block" }, [
              _c("div", { staticClass: "title_block" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$store.getters.t("our_feedback")))
                ]),
                _vm._v(" "),
                _c("div")
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "feedback_block",
              staticClass: "feedback_block",
              attrs: { id: "feedback_block" }
            },
            [
              _c(
                "div",
                { staticClass: "wrapper clearfix" },
                _vm._l(_vm.feedbacks, function(feedback, index) {
                  return _c(
                    "div",
                    {
                      key: feedback.id,
                      class: [
                        index % 2 === 0
                          ? "left_block block clearfix"
                          : "right_block block clearfix"
                      ]
                    },
                    [
                      index % 2 === 0
                        ? [
                            _c("div", { staticClass: "img" }, [
                              _c("img", {
                                attrs: {
                                  src: feedback.user.avatar
                                    ? feedback.user.avatar.image
                                    : feedback.user.photo
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "message_name" }, [
                              _c("div", { staticClass: "message" }, [
                                _vm._v(_vm._s(feedback.comment))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "name" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      (feedback.user.name || "") +
                                        " " +
                                        (feedback.user.surname || "")
                                    ) +
                                    "\n                "
                                )
                              ])
                            ])
                          ]
                        : [
                            _c("div", { staticClass: "message_name" }, [
                              _c("div", { staticClass: "message" }, [
                                _vm._v(_vm._s(feedback.comment))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "name" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      (feedback.user.name || "") +
                                        " " +
                                        (feedback.user.surname || "")
                                    ) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "img" }, [
                              _c("img", {
                                attrs: {
                                  src: feedback.user.avatar
                                    ? feedback.user.avatar.image
                                    : feedback.user.photo
                                }
                              })
                            ])
                          ]
                    ],
                    2
                  )
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "add_message" }, [
            _c(
              "div",
              { staticClass: "wrapper" },
              [
                _vm.$store.getters.user
                  ? [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.sendComment($event)
                            }
                          }
                        },
                        [
                          !(_vm.$store.getters.user.name || "").trim()
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min:3",
                                    expression: "'required|min:3'"
                                  }
                                ],
                                staticClass: "inp_type",
                                class: _vm.errors.first("commenter_name")
                                  ? "invalid"
                                  : "",
                                attrs: {
                                  placeholder: _vm.$store.getters.t("name"),
                                  name: "commenter_name",
                                  type: "text",
                                  required: ""
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !(_vm.$store.getters.user.surname || "").trim()
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min:3",
                                    expression: "'required|min:3'"
                                  }
                                ],
                                staticClass: "inp_type",
                                class: _vm.errors.first("commenter_surname")
                                  ? "invalid"
                                  : "",
                                attrs: {
                                  placeholder: _vm.$store.getters.t("surname"),
                                  name: "commenter_surname",
                                  type: "text",
                                  required: ""
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.comment,
                                expression: "comment"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:20",
                                expression: "'required|min:20'"
                              }
                            ],
                            class: _vm.errors.first("comment") ? "invalid" : "",
                            attrs: {
                              placeholder: "Напишите сообщения",
                              name: "comment",
                              required: ""
                            },
                            domProps: { value: _vm.comment },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.comment = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "add_send",
                            attrs: { type: "submit" },
                            domProps: { value: _vm.$store.getters.t("send") }
                          })
                        ]
                      )
                    ]
                  : [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.comment,
                                expression: "comment"
                              }
                            ],
                            attrs: { placeholder: "Напишите сообщения" },
                            domProps: { value: _vm.comment },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.comment = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "add_send",
                            attrs: { type: "submit" },
                            domProps: { value: _vm.$store.getters.t("send") },
                            on: {
                              click: function($event) {
                                return _vm.$store.commit("loginModal", true)
                              }
                            }
                          })
                        ]
                      )
                    ]
              ],
              2
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "slider_resume" }, [
      _c("div", { staticClass: "fix_bg" }, [
        _c("img", { attrs: { src: "/vue/images/cv-slider/cv-bg.png" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container_head_cv" }, [
        _c("div", { staticClass: "active" }, [
          _c("img", { attrs: { src: "/vue/images/cv-slider/hand3.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/hand5.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/hand7.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/hand.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/hand2.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/hand6.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/hand8.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/hand9.png" } })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container_head_cv_mob" }, [
        _c("div", { staticClass: "active" }, [
          _c("img", { attrs: { src: "/vue/images/cv-slider/mobcv-03.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/mobcv-05.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/mobcv-07.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/mobcv-08.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/mobcv-09.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/mobcv-02.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/mobcv-06.png" } })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", { attrs: { src: "/vue/images/cv-slider/mobcv-01.png" } })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "number" }, [
      _c("span", { staticClass: "counter_number" }, [_vm._v("7")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "number" }, [
      _c("span", { staticClass: "counter_number" }, [_vm._v("2k")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "number" }, [
      _c("span", { staticClass: "counter_number" }, [_vm._v("21")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9aac016", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9aac016","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Home.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a9aac016","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Home.vue
// module chunks = 0